import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import ClvrScreenControl from '../Classes/ClvrScreenControl'
import { ClvrScreenControlDto } from '../Types/ClvrScreenControlDto'
import { get } from 'lodash'
import { ClvrScreenControlTemplateApiAdapter } from './ClvrScreenControlTemplateApiAdapter'
import { OperatingRoomApiAdapter } from '../../../dPbloc/vue/Adapters/OperatingRoomApiAdapter'
import { ScreenControlData } from '../Types/ScreenControlData'
import Room from '../../../dPbloc/vue/Classes/ClvrRoom'

export class ClvrScreenControlApiAdapter implements ApiDataAdapter<ClvrScreenControl> {
    public createClass(apiData: ClvrScreenControlDto): ClvrScreenControl {
        const refTemplate = get(apiData, '_ref_template')
        const refOperatingRoom = get(apiData, '_ref_bloc_operatoire')
        const refRooms = get(apiData, '_ref_salles')

        const data: ScreenControlData = {
            id: get(apiData, 'id'),
            name: get(apiData, 'name'),
            templateId: get(apiData, 'sc_template_id'),
            operatingRoomId: get(apiData, 'bloc_operatoire_id'),
            isActive: get(apiData, 'is_active'),
            groupId: get(apiData, 'group_id'),
            creationDate: get(apiData, 'creation_date'),
            updateDate: get(apiData, 'update_date'),
            rooms: Room.convertDtoToRoomList(refRooms),
        }

        const screenControl = new ClvrScreenControl(data)
        if (refTemplate) {
            screenControl.template = new ClvrScreenControlTemplateApiAdapter().createClass(refTemplate)
        }
        if (refOperatingRoom) {
            screenControl.operatingRoom = new OperatingRoomApiAdapter().createClass(refOperatingRoom)
        }

        return screenControl
    }
}
